import { Alert, Button, Spin, message } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { SpaceAdminPage as SpaceAdminPanel } from '@modeling/spaces';
import { useTenantContext } from '@modeling/account';
import { useAdminScope } from '../../context/AdminScopeContext';

export function TenantSpaceAdminPage() {
  const { tenantId } = useParams<{ tenantId: string }>();
  const navigate = useNavigate();
  const { activeTenantId, loading: tenantLoading, switchTenant, switching } = useTenantContext();
  const { scope } = useAdminScope();

  const handleSwitchTenant = async () => {
    if (!tenantId) return;
    try {
      await switchTenant(tenantId);
      message.success('已切换活动租户');
    } catch (err) {
      message.error(err instanceof Error ? err.message : '切换租户失败');
    }
  };

  if (!scope?.isPlatformAdmin) {
    return <Alert type="error" message="仅平台管理员可管理空间" />;
  }

  if (tenantLoading || !tenantId) {
    return <Spin />;
  }

  const aligned = activeTenantId === tenantId;

  return (
    <div>
      <Button
        icon={<ArrowLeftOutlined />}
        onClick={() => navigate(`/tenants/${tenantId}`)}
        style={{ marginBottom: 16 }}
      >
        返回租户详情
      </Button>
      {!aligned ? (
        <Alert
          type="warning"
          showIcon
          message="活动租户未对齐"
          description={
            <>
              当前登录的活动租户与目标租户不一致，无法管理该租户下的空间。请重新登录并选择该租户，或点击下方按钮切换。
              <div style={{ marginTop: 12 }}>
                <Button type="primary" loading={switching} onClick={() => void handleSwitchTenant()}>
                  切换至此租户
                </Button>
              </div>
            </>
          }
        />
      ) : (
        <SpaceAdminPanel />
      )}
    </div>
  );
}
